// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { red_select, red_voice_idle_3, red_voice_stretch, red_voice_release_2, red_voice_impact_2, red_voice_death_2, red_voice_shockwave, red_shockwave, yellow_select, yellow_voice_idle, yellow_voice_stretch_2, yellow_voice_release_3, yellow_voice_impact_2, yellow_voice_death_2, yellow_voice_boost, yellow_boost, blue_select, blue_voice_idle, blue_voice_stretch_2, blue_voice_release_2, blue_voice_impact_3, blue_voice_death, blue_voice_split, blue_split, black_select, black_voice_idle_2, black_voice_stretch_3, black_voice_release_2, black_voice_impact_3, bomb_buildup, terence_select, terence_voice_stretch_2, terence_voice_release, terence_voice_impact_2, terence_voice_death_2, matilda_select, matilda_voice_idle_3, matilda_voice_stretch, matilda_voice_release_4, matilda_voice_impact, matilda_voice_death_2, matilda_voice_eggdrop_3, egg_drop, minion_pig_idle, minion_pig_hurt_2, minion_pig_death, minion_pig_scared, minion_pig_giggle_long_2, minion_pig_laugh_3, minion_pig_snore_inhale_2, minion_pig_snore_exhale_2, minion_pig_flying_death_3, rock_impact_medium, rock_damaged_3, rock_destroyed_3, wood_impact_medium_2, wood_damaged_3, wood_destroyed, ice_impact_medium_2, ice_damaged_3, ice_destroyed_2, tnt_explosion, slingshot_stretch_soft, slingshot_fire, sfx_generalbutton, tnt_spawn, pigshield_spawn, pigshield_afterspawn, iceshower_spawn, iceshower_afterspawn, stonenator_spawn, swappigs_spawn, bar_swoosh_in, bar_swoosh_out, mus_lobby, mus_ingame, amb_cobaltplateau, mus_stinger_win, mus_stinger_lose, ui_select, ui_back, ui_entergame, ui_replaytv_explosion, ui_explosion, initializeAudio } from "../code/AssetDefinitions/SoundDefinitions";
import { tgfAudio } from "../framework/tgfAudio";
export var SoundManager = {};
initializeAudio();
SoundManager.BIRD_STATE = {
    SELECT: "select",
    IDLE: "idle",
    STRETCH: "stretch",
    RELEASE: "release",
    IMPACT: "impact",
    DEATH: "death",
    ABILITY: "ability"
};
SoundManager.BirdCollection = {
    RED: {
        "select": red_select,
        "idle": red_voice_idle_3,
        "stretch": red_voice_stretch,
        "release": red_voice_release_2,
        "impact": red_voice_impact_2,
        "death": red_voice_death_2,
        "ability": [red_voice_shockwave, red_shockwave]
    },
    YELLOW: {
        "select": yellow_select,
        "idle": yellow_voice_idle,
        "stretch": yellow_voice_stretch_2,
        "release": yellow_voice_release_3,
        "impact": yellow_voice_impact_2,
        "death": yellow_voice_death_2,
        "ability": [yellow_voice_boost, yellow_boost]
    },
    BLUE: {
        "select": blue_select,
        "idle": blue_voice_idle,
        "stretch": blue_voice_stretch_2,
        "release": blue_voice_release_2,
        "impact": blue_voice_impact_3,
        "death": blue_voice_death,
        "ability": [blue_voice_split, blue_split]
    },
    BLACK: {
        "select": black_select,
        "idle": black_voice_idle_2,
        "stretch": black_voice_stretch_3,
        "release": black_voice_release_2,
        "impact": [black_voice_impact_3, bomb_buildup],
        //"death": tnt_explosion
        //"ability": bomb_buildup
    },
    BIG: {
        "select": terence_select,
        "stretch": terence_voice_stretch_2,
        "release": terence_voice_release,
        "impact": terence_voice_impact_2,
        "death": terence_voice_death_2,
    },
    MATILDA: {
        "select": matilda_select,
        "idle": matilda_voice_idle_3,
        "stretch": matilda_voice_stretch,
        "release": matilda_voice_release_4,
        "impact": matilda_voice_impact,
        "death": matilda_voice_death_2,
        "ability": [matilda_voice_eggdrop_3, egg_drop]
    }
};
SoundManager.PIG_STATE = {
    IDLE: "idle",
    HURT: "hurt",
    DEATH: "death",
    SCARED: "scared",
    CHUCKLING: "chuckling",
    LAUGHING: "laughing",
    SLEEPING: "sleeping",
    FLY_DEATH: "flyDeath"
};
SoundManager.PigCollection = {
    PIG: {
        "idle": minion_pig_idle,
        "hurt": minion_pig_hurt_2,
        "death": minion_pig_death,
        "scared": minion_pig_scared,
        "chuckling": minion_pig_giggle_long_2,
        "laughing": minion_pig_laugh_3,
        "sleeping": [minion_pig_snore_inhale_2, minion_pig_snore_exhale_2],
        "flyDeath": minion_pig_flying_death_3
    }
};
SoundManager._pigSoundManager = [];
SoundManager._soundTimer = 7000;
SoundManager.MATERIAL_STATE = {
    IMPACT: "impact",
    DAMAGE: "damage",
    DESTROY: "destroy"
};
SoundManager.SLINGSHOT_STATE = {
    STRETCH: "stretch",
    FIRE: "fire"
};
SoundManager.MaterialCollection = {
    STONE: {
        "impact": rock_impact_medium,
        "damage": rock_damaged_3,
        "destroy": rock_destroyed_3
    },
    WOOD: {
        "impact": wood_impact_medium_2,
        "damage": wood_damaged_3,
        "destroy": wood_destroyed
    },
    ICE: {
        "impact": ice_impact_medium_2,
        "damage": ice_damaged_3,
        "destroy": ice_destroyed_2
    },
    TNT: {
        "destroy": tnt_explosion
    },
    SLINGSHOT: {
        "stretch": slingshot_stretch_soft,
        "fire": slingshot_fire
    }
};
SoundManager.PowerUpCollection = {
    "BombDrop": {
        "select": sfx_generalbutton,
        "spawn": tnt_spawn
    },
    "Shield": {
        "select": sfx_generalbutton,
        "spawn": [pigshield_spawn, pigshield_afterspawn]
    },
    "FreezeRay": {
        "select": sfx_generalbutton,
        "spawn": [iceshower_spawn, iceshower_afterspawn]
    },
    "StoneNator": {
        "select": sfx_generalbutton,
        "spawn": stonenator_spawn
    },
    "SwapPigs": {
        "select": sfx_generalbutton,
        "spawn": swappigs_spawn
    },
    Bar: {
        "swooshIn": bar_swoosh_in,
        "swooshOut": bar_swoosh_out
    }
};
SoundManager.MUSIC_STATE = {
    LOBBY: "lobby",
    GAME: "game",
    AMBIENCE: "ambience",
    STINGER_WIN: "stingerWin",
    STINGER_LOSE: "stingerLose"
};
SoundManager.MusicCollection = {
    "lobby": mus_lobby,
    "game": mus_ingame,
    "ambience": amb_cobaltplateau,
    "stingerWin": mus_stinger_win,
    "stingerLose": mus_stinger_lose
};
SoundManager.UI_STATE = {
    SELECT: "select",
    BACK: "back",
    ENTER_GAME: "enterGame",
    REPLAY_TV_EXPLOSION: "replayTVExplosion",
    EXPLOSION: "explosion"
};
SoundManager.UICollection = {
    "select": ui_select,
    "back": ui_back,
    "enterGame": ui_entergame,
    "replayTVExplosion": ui_replaytv_explosion,
    "explosion": ui_explosion
};
SoundManager.unloadedSounds = [];
SoundManager.mutedPigs = false;
SoundManager.playEffect = function (state, collection, delay, repeat) {
    var _delay = delay ? delay : 0, _item = null, _id, _repeat = repeat ? repeat : false;
    if (collection && collection[state]) {
        _item = collection[state];
    }
    else {
        return;
    }
    if (Object.prototype.toString.call(_item) === '[object Array]') {
        var itemDelay = 0;
        for (var i = 0; i < _item.length; i++) {
            _id = SoundManager._play(_item[i], _delay, _repeat);
        }
    }
    else {
        _id = SoundManager._play(_item, _delay, _repeat);
    }
    return _id;
};
SoundManager._play = function (item, delay, repeat) {
    var _id = tgfAudio.play(item, delay, undefined, undefined, repeat);
    if (_id == -1) {
        SoundManager.unloadedSounds.push({ item: item, delay: delay, repeat: repeat });
    }
    return _id;
};
SoundManager.playSequence = function (state, collection, repeatTime) {
    var _repeat = repeatTime ? repeatTime : 0, _item = null, _id;
    if (collection && collection[state]) {
        _item = collection[state];
    }
    else {
        return;
    }
    if (Object.prototype.toString.call(_item) === '[object Array]') {
        var itemDelay = 500, prevDelay = 0;
        for (var j = 0; j < _repeat; j++) {
            for (var i = 0; i < _item.length; i++) {
                _id = tgfAudio.play(_item[i], itemDelay);
                prevDelay = _item[0].duration + 100;
                if (_item[i + 1]) {
                    itemDelay += _item[i].duration;
                }
            }
            itemDelay += prevDelay;
        }
    }
    return _id;
};
SoundManager.checkForLoadedSounds = function () {
    for (var i = SoundManager.unloadedSounds.length - 1; i >= 0; i--) {
        var sound = SoundManager.unloadedSounds[i];
        if (sound.item.sprite.loaded) {
            var id = SoundManager._play(sound.item, sound.delay, sound.repeat);
            if (id != -1) {
                SoundManager.unloadedSounds.splice(i, 1);
            }
        }
    }
};
SoundManager.update = function (timePassed) {
    SoundManager._soundTimer -= timePassed;
};
SoundManager.reset = function (timePassed) {
    SoundManager._soundTimer = 5000;
};
